export default "__VITE_ASSET__CZqRm4Z___"